const routes = [
    {
        path: "/unofficial/transcript",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            isUserTypeStudent: true
        }
    }
];

export default routes;
